<template>
  <div>
    <index-header></index-header>
    <index-banner v-if="banners && banners.length > 0" :items="banners"></index-banner>
    <index-hot-stores :items='storeList'></index-hot-stores>
    <index-menu></index-menu>
    <index-ad :items='hotad'></index-ad>
    <!-- 版权信息 -->
    <div class="copyright" v-if="config">
      <!-- <div><a href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank">{{config.wab_number}}</a></div>
      <div><a href="https://beian.miit.gov.cn" target="_blank">{{config.icp_number}}</a></div> -->
      <div>{{config.flow_static_code}}</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Toast } from 'mint-ui'
import { getAppadList, homeIndexNavList,homeIndexGoodsList } from '../../../api/homeindex'
import { getStoreList } from '../../../api/homesearch'
import IndexHeader from './IndexHeader'
import IndexBanner from './IndexBanner'
import IndexAd from './IndexAd'
import IndexHotStores from './IndexHotStores'
import IndexMenu from './IndexMenu'
import { Position } from '@/const/appadv'

export default {
  name: 'HomeIndex',
  data () {
    return {
      banners: [],
      hotad:'',
      storeList: [],
    }
  },
  components: {
    IndexHeader,
    IndexBanner,
    IndexAd,
    IndexHotStores,
    IndexMenu
  },
  mounted () {
  },
  created: function () {
    getAppadList(Position.MAIN_SWIPE_ID).then(
      (response) => {
        if (response.result && response.result.ad_list) {
          this.banners = response.result.ad_list
        }
      })
    getAppadList(Position.MAIN_ADV_ID).then(
      (response) => {
            if (response.result && response.result.ad_list) {
              this.hotad = response.result.ad_list
        }
      })
    let member_point = this.member_point
    if (!member_point) {
      // this.$router.push({ name: 'HomeMap' })
      return
    }
    getStoreList(
      '',
      '',
      '',
      member_point.lng,
      member_point.lat,
      '',
      1,
      this.token,
      true
    ).then(res => {
      this.storeList = res.result.store_list
    })
  },
  computed: {
    ...mapState({
      config: state => state.config.config,
      member_point: state => state.member.point,
      token: state => state.member.token,
    })
  },
  methods: {
  }
}
</script>

<style scoped>
.copyright{font-size:.65rem;color:#999;text-align: center;padding:.8rem 0;}
</style>
